import { render, staticRenderFns } from "./animatedLoader.vue?vue&type=template&id=46d28f79&scoped=true&"
import script from "./animatedLoader.vue?vue&type=script&lang=js&"
export * from "./animatedLoader.vue?vue&type=script&lang=js&"
import style0 from "./animatedLoader.vue?vue&type=style&index=0&id=46d28f79&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d28f79",
  null
  
)

export default component.exports